import { useTranslation } from 'react-i18next';
import { Avatar, Button, Card, Flex, Sheet, Text } from '@/components/common';
import { useCurrentUser } from '@/contexts';
import { firstPhotoUrl } from '@/utils';

interface OwnNoteActionsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  text: string;
  onNewNote: () => void;
  onDelete: () => void;
  deleting?: boolean;
}

export function OwnNoteActionsDialog({
  open,
  onOpenChange,
  text,
  onNewNote,
  onDelete,
  deleting = false,
}: OwnNoteActionsDialogProps) {
  const { t } = useTranslation('notes');
  const { currentUser } = useCurrentUser();

  return (
    <Sheet.Root open={open} onOpenChange={onOpenChange}>
      <Sheet.Content>
        <Sheet.Title className="sr-only">{t('actions.title')}</Sheet.Title>
        <Flex direction="column" gap="4" px="4" pb="4" pt="1">
          <Flex direction="column" align="center" gap="2">
            <Avatar
              name={t('circle.you')}
              src={firstPhotoUrl(currentUser?.photos)}
              size="4"
              radius="full"
            />
            <Text size="1" weight="bold" className="font-mono">
              {t('circle.you')}
            </Text>
          </Flex>
          <Card variant="surface">
            <Text size="2">{text}</Text>
          </Card>
          <Flex direction="column" gap="2">
            <Sheet.Close asChild>
              <Button
                type="button"
                variant="outline"
                color="gray"
                fullWidth
                onClick={onNewNote}
                data-testid="note-action-new"
              >
                {t('actions.new')}
              </Button>
            </Sheet.Close>
            <Button
              type="button"
              variant="outline"
              color="crimson"
              fullWidth
              isLoading={deleting}
              onClick={onDelete}
              data-testid="note-action-delete"
            >
              {t('actions.delete')}
            </Button>
          </Flex>
        </Flex>
      </Sheet.Content>
    </Sheet.Root>
  );
}
